export default {
  企业申请认证: '企业申请认证',
  展厅服务: '展厅服务',
  查看更多: '查看更多',
  于: '于',
  发布: '发布',
  云展动力首页: '云展动力首页',
  扫码下载: '扫码下载',
  云展动力APP: '云展动力APP',
  分享: '分享',
  参展报名: '参展报名',
  申请加入: '申请加入',
  '3D展览': '3D展览',
  了解更多: '了解更多',
  进场人数: '进场人数',
  访问人数: '访问人数',
  参展企业: '参展企业',
  入链企业: '入链企业',
  企业展品: '企业展品',
  供应产品: '供应产品',
  企业3D: '企业3D',
  元宇宙会客厅: '元宇宙会客厅',

  面议: '面议',
  照片直播: '照片直播',
  '3D产品': '3D产品',
  '3D企业': '3D企业',
  '3D全景': '3D全景',
  展品: '展品',
  直播: '直播',
  请输入关键词: '请输入关键词',
  服务与承诺: '服务与承诺',
  主页: '主页',
  在线洽谈: '在线洽谈',
  // no use
  产品: '产品',
  参展的展览: '参展的展览',
  我的直播间: '我的直播间',
  直播预告: '直播预告',
  直播中: '直播中',
  直播回放: '直播回放',
  预告: '预告',
  联系信息: '联系信息',
  联系方式: '联系方式',
  收藏: '收藏',
  取消收藏: '取消收藏',
  // no use
  回放: '回放',
  产品规格: '产品规格',
  立即报名: '立即报名',
  立即注册: '立即注册',
  修改并登录: '修改并登录',
  开展时间: '开展时间',
  展览地点: '展览地点',
  参展提示长: '提示：报名成功后,主办方会跟您联系沟通,并提供相关展览的其他资料给您,如门票、交通路线等',
  '3D企业全貌': '3D企业全貌',
  企业未上传内容提示: '该企业暂未上传内容,敬请期待',
  账号注册: '账号注册',
  找回密码: '找回密码',
  协议: '协议',
  还没有账号: '还没有账号？',
  全部: '全部',
  电子电器: '电子电器',
  机械工业: '机械工业',
  五金塑料: '五金塑料',
  家居用品: '家居用品',
  综合其他: '综合其他',
  数字经济: '数字经济',
  创新环境: '创新环境',
  高端装备制造: '高端装备制造',
  国际交流合作: '国际交流合作',
  新材料能源: '新材料能源',
  综合展览: '综合展览',
  微信订阅号: '微信订阅号',
  微信服务号: '微信服务号',
  免责声明详情:
    '本网站所显示的信息或资料均来源于各国展览企业、机构信息内容,由云展动力网及网站会员共同负责具体编译和更新发布,网站已尽严格审核义务,仅供参考。因办展过程的不可控性,部分展会可能会存在延期或取消举行的情况,请您参展前务必再次与组织方或展馆方核实。针对信息内容的准确性、完整性、合法性、可靠性、可操作性或可用性,以及使用本网站提供的信息所造成的直接的、间接的、附带的、特殊的损失、债务或商务中断等,本网站不承担任何责任。',
  展览简介: '展览简介',
  当前届次: '当前届次',
  举办周期: '举办周期',
  展览范围: '展览范围',
  组织机构: '组织机构',
  主办单位: '主办单位',
  支持单位: '支持单位',
  协办单位: '协办单位',
  承办单位: '承办单位',
  参观商: '参观商',
  主办商: '主办商',
  参展商: '企业',
  参展商报名: '参展商报名',
  上一页: '上一页',
  下一页: '下一页',
  敬请期待: '敬请期待',
  企业3D全貌: '企业3D全貌',
  暂无参展企业: '暂无参展企业',
  打开微信扫一扫看企业: '打开微信扫一扫看企业',
  打开微信扫一扫看展览: '打开微信扫一扫看展览',
  也可截图分享给您好友: '也可截图分享给您好友',
  '抱歉,没有找到': '抱歉,没有找到',
  推荐列表: '推荐列表',
  免责声明: '免责声明',
  您的浏览器不支持video标签: '您的浏览器不支持 video 标签',
  提交: '提交',
  微信扫一扫: '微信扫一扫',
  搜索匹配不到参展企业提示1: '抱歉,没有找到',
  搜索匹配不到参展企业提示2: '的相关参展企业',
  订单购买成功提示: '您也可以在个人中心-订单管理,找到该订单点击观看',
  线下展览: '线下展览',
  会议: '会议',
  模型: '模型',
  海报: '海报',
  复制链接: '复制链接',
  我的云企业: '我的云企业',
  产品服务: '产品服务',
  已参展的展览: '已参展的展览',
  云展览: '云展览',
  我的云直播: '我的云直播',
  企业动态: '企业动态',
  投资: '投资',
  我的投资机构: '我的投资机构',
  我的对外投资: '我的对外投资',
  暂无数据: '暂无数据',
  主营产品: '主营产品',
  动态详情: '动态详情',
  请输入正确的验证码: '请输入正确的验证码',
  收藏成功: '收藏成功!',
  取消收藏成功: '取消收藏成功!',
  '暂不认证,跳过': '暂不认证,跳过',
  请注册账号: '请注册账号',
  去完善名片: '去完善云展',
  请完善个人名片信息: '请完善个人云展信息',
  请完善当前语言的个人名片信息: '请完善当前语言的个人云展信息',
  已退出登录: '已退出登录',
  已发布的会议: '已发布的会议',
  已发布的展览: '已发布的展览',
  发送: '发送',
  Ta的名片: 'Ta的个人云展',
  回放页: '回放页',
  回到顶部: '回到顶部',
  友情链接: '友情链接',
}
